// extracted by mini-css-extract-plugin
export default {"filter":"mXSXERsURUw7XmCBfgNN"};